var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useState, useRef, useEffect } from "react";
var isServer = typeof window === "undefined";
var RenderIfVisible = function (_a) {
    var _b = _a.defaultHeight, defaultHeight = _b === void 0 ? 1 : _b, _c = _a.visibleOffset, visibleOffset = _c === void 0 ? 1000 : _c, _d = _a.root, root = _d === void 0 ? null : _d, children = _a.children;
    var _e = useState(isServer), isVisible = _e[0], setIsVisible = _e[1];
    var placeholderHeight = useRef(defaultHeight);
    var obersverRef = useRef(null);
    var intersectionRef = useRef(null);
    // Set visibility with intersection observer
    useEffect(function () {
        if (intersectionRef.current) {
            obersverRef.current = new IntersectionObserver(function (entries) {
                if (typeof window !== undefined &&
                    // @ts-ignore
                    window.requestIdleCallback) {
                    // @ts-ignore
                    window.requestIdleCallback(function () { return setIsVisible(entries[0].isIntersecting); }, {
                        timeout: 600,
                    });
                }
                else {
                    setIsVisible(entries[0].isIntersecting);
                }
            }, { root: root, rootMargin: "".concat(visibleOffset, "px 0px ").concat(visibleOffset, "px 0px") });
            obersverRef.current.observe(intersectionRef.current);
            return function () {
                if (obersverRef.current) {
                    obersverRef.current.disconnect();
                }
            };
        }
        return function () { };
    }, [intersectionRef]);
    // Set true height for placeholder element after render.
    useEffect(function () {
        if (intersectionRef.current && isVisible) {
            placeholderHeight.current = intersectionRef.current.offsetHeight;
        }
    }, [isVisible, intersectionRef]);
    return (_jsx("div", __assign({ ref: intersectionRef }, { children: isVisible ? (_jsx(_Fragment, { children: children })) : (_jsx("div", { style: { height: placeholderHeight.current } })) })));
};
export default RenderIfVisible;
//# sourceMappingURL=RenderIfVisible.js.map